export default "/_next/static/media/Nordic Flowers.187f943c769765d07f4814c5c310faab.jpeg";